import apiClient from '@/api/client';

export interface WizardStep {
  step: number;
  key: string;
  label: string;
  required: boolean;
}

export interface SetupStatus {
  steps: WizardStep[];
  current_step: number;
  completed_steps: number[];
  completed_at: string | null;
  setup_mode: 'self' | 'accountant' | null;
  is_complete: boolean;
  skipped: boolean;
  /** Company data collected at signup — used to pre-fill wizard Step 2 */
  company?: {
    name: string;
    country_code: string;
    industry: string | null;
    email: string | null;
    phone: string | null;
  };
  /** Modules available on the current plan (for Step 8 gating) */
  plan_modules?: string[] | null;
  /** B1: industry-derived template suggestion for Step 8 pre-selection */
  suggested_template_key?: string | null;
}

/**
 * Per-item record counts for the SettingsSetupPage checklist.
 * Keys match the step `key` values used in SettingsSetupPage.tsx.
 * Value = row count (0 = not set up, >0 = has data).
 */
export interface SetupChecklist {
  departments: number;
  coa: number;
  revenue_types: number;
  expense_cats: number;
  payment_methods: number;
  designations: number;
  leave_types: number;
  holidays: number;
  onboarding_templates: number;
  employees: number;
  users: number;
  employer_banks: number;
  tracking_categories: number;
}

export const setupWizardApi = {
  getStatus: () =>
    apiClient.get<SetupStatus>('/settings/setup/status'),
  getChecklist: () =>
    apiClient.get<SetupChecklist>('/settings/setup/checklist'),
  completeStep: (stepNumber: number, data?: Record<string, unknown>) =>
    apiClient.post(`/settings/setup/step/${stepNumber}`, { data }),
  completeSetup: () =>
    apiClient.post('/settings/setup/complete'),
  skipSetup: () =>
    apiClient.post('/settings/setup/skip'),
};
